module.exports = __webpack_public_path__ + "img/manage-title.35e925fd.png";